import {request} from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";
import ResponseTypes from "../../constants/ResponseTypes";

export async function getLeaseProcessingResults(data) {
    return await request('/api/leaseRenewal/processing', data);
}

export async function generateLeaseRenewalPdf(data) {
    return await request('/api/leaseRenewal/processing/generatePdf', data, HttpMethod.POST, { responseType: ResponseTypes.BLOB });
}

export async function getAllLeaseProcessingReports() {
    return await request('/api/leaseRenewal/processing/reports');
}

export async function createLeaseProcessingReport(data, fromDate, toDate) {
    return await request(`/api/leaseRenewal/processing/create-report?fromDate=${fromDate}&toDate=${toDate}`, data, HttpMethod.POST);
}

export function loadLeaseProcessingReport(id, page = 0, size = 30) {
    return request("api/leaseRenewal/processing/load-report/" + id, { page, size }, HttpMethod.GET);
}

export function generateLeasePrePdf(id) {
    return request('/api/leaseRenewal/processing/pre-report/' + id, {}, HttpMethod.GET, { responseType: ResponseTypes.BLOB });
}

export async function updateLeaseProcessingReport(reportId, data) {
    return await request(`/api/leaseRenewal/processing/reports/${reportId}/update`, data, HttpMethod.POST);
}